//引入封装的方法和接口域名
import { postRequest, getRequest } from "./axios";
import { baseUrl, baseUrl_New } from "./urlconfig";

export const postDemo=(data)=>{
    return postRequest(`${baseUrl}/android/test`,data)
}

export const getDemo=(data)=> {
    return getRequest(`${baseUrl_New}/issuecompany`, data)
}

export const login=(data)=> {
    return postRequest(`${baseUrl_New}/login`, data)
}

export const addRowIssue=(data)=> {
    return postRequest(`${baseUrl_New}/addrow`, data)
}

export const deleteIssue=(data)=> {
    return postRequest(`${baseUrl_New}/delissue`, data)
}

export const updStatus=(data)=> {
    return postRequest(`${baseUrl_New}/updstatus`, data)
}

export const changeissue=(data)=> {
    return postRequest(`${baseUrl_New}/changeissue`, data)
}

export const getalltype=(data)=> {
    return getRequest(`${baseUrl_New}/alltype`, data)
}

export const editQTDisable=(data)=> {
    return postRequest(`${baseUrl_New}/editQTDisable`, data)
}

export const getallcustomer=(data)=> {
    return getRequest(`${baseUrl_New}/allcustomer`, data)
}

export const getallrole=(data)=> {
    return getRequest(`${baseUrl_New}/allrole`, data)
}

export const insertUser=(data)=> {
    return postRequest(`${baseUrl_New}/insertuser`, data)
}

export const addType=(data)=> {
    return postRequest(`${baseUrl_New}/addtype`, data)
}
export const deleteType=(data)=> {
    return postRequest(`${baseUrl_New}/deletetype`, data)
}

export const getusercompany=(data)=> {
    return getRequest(`${baseUrl_New}/selectcompany`, data)
}

export const getcustomercompany=(data)=> {
    return getRequest(`${baseUrl_New}/allcustomercompany`, data)
}

export const insertcustomercompany=(data)=> {
    return postRequest(`${baseUrl_New}/insertcustomercompany`, data)
}

export const getallurgency=(data)=> {
    return getRequest(`${baseUrl_New}/allurgency`, data)
}

export const changeurgency=(data)=> {
    return postRequest(`${baseUrl_New}/updateissueurgency`, data)
}

export const getalluser=(data)=> {
    return getRequest(`${baseUrl_New}/getalluser`, data)
}

export const getuserbycompany=(data)=> {
    return getRequest(`${baseUrl_New}/getuserbycompany`, data)
}

export const deleteUser=(data)=> {
    return postRequest(`${baseUrl_New}/deleteuser`, data)
}

export const banUser=(data)=> {
    return postRequest(`${baseUrl_New}/banuser`, data)
}

export const updateUser=(data)=> {
    return postRequest(`${baseUrl_New}/updateuser`, data)
}
export const kball=(data)=> {
    return getRequest(`${baseUrl_New}/allkb`, data)
}
export const upload=(data)=> {  //文件上传
    return postRequest(`${baseUrl_New}/oss/file/upload`,{
    headers: {
        'Content-Type': 'multipart/form-data'    //路由更改
      }
    },
     data)
}
export const getIssues=(data)=> {  //分页demo
    return getRequest(`${baseUrl_New}/issue/pages/1/10`, data)
}
export const addAppUpdate=(data)=> {  // 文件上传
    return postRequest(`${baseUrl_New}/issue/upload`, data)
}

export const uploadFile=(data)=> {  // 附件上传
    return postRequest(`${baseUrl_New}/oss/file/uploadFile`, data)
}
export const handleLoad=(data)=> { // 附件下载
    return getRequest(`${baseUrl_New}/oss/file/downloadFile`, data)
} 
export const registry=(data)=> { // 注册
    return postRequest(`${baseUrl_New}/registry`, data)
} 
export const issueFileAdd=(data)=> {  // issue多附件上传
    return postRequest(`${baseUrl_New}/oss/issue/issueOss`, data)
}
export const uploadRes=(data)=> {  // issue多附件上传
    return postRequest(`${baseUrl_New}/oss/issue/resFile`, data)
}
export const getTypeAll=(data)=> {
    return getRequest(`${baseUrl_New}/kType/list`, data)
}
export const changeChargeTime=(data) => {
    return postRequest(`${baseUrl_New}/change/chargetime`, data)
}
